import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CookieService {
  public getCookie(cookieName: string): string | null {
    const name = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(";");

    for (let cookie of cookies) {
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }

    return null;
  }
  public setCookie(cookieName: string, content: string): void {
    document.cookie = `${cookieName}=${content};path=/;`;
  }

  public deleteCookie(cookieName: string): void {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;`;
  }
}
